import { DateTime, Info } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Sentinel for the "Next 7 days" dropdown option — resolved to a concrete weekday before persisting.
export const NEXT_7_DAYS_VALUE = -1;

// Info.weekdays("short") is Monday-first; remap so option value 0=Sun..6=Sat.
const SHORT_WEEKDAYS = Info.weekdays("short");
const WEEKDAY_OPTIONS = Array.from({ length: 7 }, (_, value) => ({ value, label: SHORT_WEEKDAYS[(value + 6) % 7] }));

/** Week-start dropdown options shared by the Staffing grid and the Profile schedule: "Next 7 days" + Sun..Sat. */
export const useWeekStartDayOptions = (): { value: number; label: string }[] => {
	const { t } = useTranslation();
	return useMemo(() => [{ value: NEXT_7_DAYS_VALUE, label: t("schedule.template.week_start.next_7_days") }, ...WEEKDAY_OPTIONS], [t]);
};

/**
 * Resolve a dropdown selection to a concrete week-start weekday (0=Sun..6=Sat). "Next 7 days" is
 * today's weekday in the DEPARTMENT timezone — not the browser's — so a cross-timezone user near
 * midnight isn't shifted onto the wrong week.
 */
export const resolveWeekStartDaySelection = (value: number, timezone: string): number =>
	value === NEXT_7_DAYS_VALUE ? DateTime.now().setZone(timezone).weekdayISO : value;
